import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UploadDocumentComponent } from '../../../components/upload-document/upload-document.component';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
@Component({
  selector: 'app-rfi',
  standalone: false,
  templateUrl: './rfi.component.html',
  styleUrl: './rfi.component.scss',
})
export class RFiComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadDocumentComponent) uploadDocumentComp!: UploadDocumentComponent;
  @Input() id: any;
  @Input() getUrl: any;
  @Input() postUrl: any;
  @Output() stepCompleted = new EventEmitter<void>();
  rfiForm: FormGroup;
  baseUrl: string = environment.APIUrl;
  payload: ProposalPayload;
  @Input() step: any;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() isEditable: boolean = false;
  isEditorDisabled: boolean = false;
  userID: any;
  commentForm: FormGroup;
  allDmsFiles: any[] = [];
  rfiId: any;
  rfiData: any;
  remark: any = '';
  // upload doc progress
  uploadProgress: number = 0;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    this.rfiForm = this.fb.group({
      // No form fields needed for document-only upload
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    console.log('rfi component', this.step);
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
    this.getRfiData();
  }



  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm?.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }

  editorReady = false;
  init: EditorComponent['init'] = init;
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }

  getRfiData() {
    const url = `/make1/upload/rfi/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    
    this.api.getAPI(url).subscribe((res: any) => {
      console.log('rfi data', res);
      
      let responseData = null;
      
      if (Array.isArray(res) && res.length > 0) {
        responseData = res[0];
      } else if (res && res.rfi) {
        responseData = res.rfi;
      } else if (res && typeof res === 'object' && !Array.isArray(res) && res.id) {
        responseData = res;
      }
      
      this.rfiData = responseData;
      
      // Handle DMS files
      this.allDmsFiles = this.rfiData?.dms_files || [];
      
      // Load remarks if exists (also populate from justification if available)
      if (responseData) {
        this.remark = responseData.comment || responseData.remark || responseData.justification || '';
        this.rfiId = responseData.id;
      }
    });
  }

  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    this.api.postAPI('/make1/upload/rfi/', formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res rfi upload data', res);
        this.getRfiData(); // Refresh data after upload
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document uploaded successfully',
        });
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document upload failed',
        });
      }
    });
  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('type_doc', updatedDoc.type_document);
    formData.append('description', updatedDoc.description);

    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    this.api.putAPI(`/make1/upload/rfi/${updatedDoc.id}/`, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
        this.getRfiData(); // Refresh data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document updated successfully',
        });
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document update failed',
        });
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.api.deleteAPI(`/make1/upload/rfi/${docId}/`).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
        this.getRfiData(); // Refresh data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document deleted successfully',
        });
      },
      error: (err) => {
        console.error('❌ Delete failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document deletion failed',
        });
      }
    });
  }

  onSubmit() {
    // if (!this.remark || this.remark.trim() === '') {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Warning',
    //     detail: 'Please enter remarks before saving',
    //   });
    //   return;
    // }

    const payload = {
      comment: this.remark,
      justification: this.remark,
      proposal_step: this.id,
    };

    if (this.rfiId) {
      this.api.putAPI(`/make1/upload/rfi/${this.rfiId}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Remarks saved successfully',
          });
          this.getRfiData();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error updating remarks:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save remarks',
          });
        }
      });
    } else {
      this.api.postAPI('/make1/upload/rfi/', payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Remarks saved successfully',
          });
          this.getRfiData();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error saving remarks:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save remarks',
          });
        }
      });
    }
  }

  generatePDF() {
    const data: any[] = [
      { key: 'Proposal Name', value: this.payload.proposal_name },
      { key: 'Remarks', value: this.remark || '' },
    ];

    const payload = {
      url: '/revenue/need/version-control/',
      data,
    };

    this.generatePDFEmitter.emit(payload);
  }

  expandedSections: { [key: string]: boolean } = {
    uploads: true
  };

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
}

interface ProposalPayload {
  proposal_id: number;
  proposal_name: string;
}
